export const TOGGLE_MODIFICATION_CONTAINER = 'TOGGLE_MODIFICATION_CONTAINER'

export function displayModificationContainerReducer (state = {value: false}, action) {
    switch (action.type){
        case TOGGLE_MODIFICATION_CONTAINER:
            return action.payload
        default: return state
    }
}